module.exports = __webpack_public_path__ + "static/ranger-rashemi-minsk-AYAGWW-1204e55f3821174aa7b620d4a4aa83ed.png";